import type { ProductReviewsRollupProperty } from '#root/api/clients/product/data-contracts'

/**
 * Retrieves the fit rating value from the provided product reviews rollup property.
 * @param property The product reviews rollup property object.
 * @param property.display_values display_values property
 * @param property.values values property
 * @returns The an object with fit rating value and label.
 * @category Utils
 */
export default function getFitRatingValues(
  { display_values, values }: ProductReviewsRollupProperty
): { value: number, label: string } {
  if (!display_values) {
    return {
      value: 0,
      label: ''
    }
  }
  let largestCount = {
    count: 0,
    label: ''
  }
  for (const obj of values) {
    if (obj.count > largestCount.count)
      largestCount = obj
  }
  const returnValue = display_values.indexOf(largestCount.label)
  return {
    value: returnValue + 1,
    label: display_values[returnValue]
  }
}
